/*
  Kiwi Ears · hide the bar over the footer (Rene 2026-08-22).

  The footer carries its own menus — the brand-links row and five link columns —
  and the bar is fixed, so at the bottom of a page two sets of navigation sit on
  top of each other. The bar slides out once the footer reaches it and comes back
  the moment you scroll up.

  Driven by ScrollTrigger rather than a raw IntersectionObserver, per CLAUDE.md,
  so the probe stays in step with Lenis; a rAF-throttled scroll listener covers
  the no-GSAP case. The trigger point is measured from the bar itself instead of
  being hardcoded, because the bar is 100px on desktop and shorter on phones.

  Two states deliberately veto the hide, both handled in CSS so this file never
  has to know about them:
    · the mobile drawer is open — it lives INSIDE #siteNav, and a transform on
      an ancestor turns `fixed` into "relative to that ancestor", which would
      crop the drawer to the height of the bar
    · something inside the bar has keyboard focus — sliding the focused element
      out of the viewport is exactly what the focus-state guidance forbids
*/
(function () {
  var nav = document.getElementById('siteNav');
  if (!nav) return;
  var footer = document.getElementById('kh-footer');
  if (!footer) return;

  /* the bar row's height, in viewport pixels — same probe kh-navtheme.js uses */
  function barHeight() {
    var row = nav.firstElementChild;
    return Math.round((row || nav).getBoundingClientRect().height) || 72;
  }

  function set(on) {
    document.body.classList.toggle('kf-hidenav', !!on);
  }

  function armScrollTrigger() {
    if (!window.gsap || !window.ScrollTrigger) return false;
    var st = window.ScrollTrigger.create({
      trigger: footer,
      start: function () { return 'top top+=' + barHeight(); },
      end: 'max',
      onToggle: function (self) { set(self.isActive); }
    });
    /* onToggle only fires on a CHANGE, so a page that loads already scrolled to
       the footer would never report itself — the same trap as the header theme
       switch and the help-hub rail. */
    set(st.isActive);
    return true;
  }

  function armFallback() {
    var queued = false;
    function tick() {
      queued = false;
      set(footer.getBoundingClientRect().top <= barHeight());
    }
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(tick);
    }, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  function start() {
    if (!armScrollTrigger()) armFallback();
  }

  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
